import { get, post , postInspect, getInspect} from '@/services/axios'

class LiveClassroom {
    //获取实时课堂教学数据列表
    getLiveListData(params: { type: string, departid:string,name:string,page:number,pageSize:string,live_type:string,}) {
        return post('/LiveBroadcastApi/livePage', params)
    }
    //获取头部汇总
    getBroadcastHeader(params: { startTime: string, endTime:string,departid:string,auth_status:string}) {
        return post('/LiveBroadcastApi/broadcastHeader', params)
    }
    //获取课堂录像详情数据
    getBroadcastCourses(params: { startTime: string, endTime:string,departid:string,page:string,name:string,auth_status:string}) {
        return post('/LiveBroadcastApi/broadcastCourses', params)
    }
    //获取回收站列表
    getRecycleBin(params: { type: string, departid:string,page:number,name:string}) {
        return post('/LiveBroadcastApi/getRecycleBin', params)
    }
    //获取查看录像详情
    getBroadcast(params: {start?: string, end?:string, type: string, kepcourseid:string,page:number}) {
        return post('/LiveBroadcastApi/broadcast', params)
    }
    //回收站彻底删除
    isDelLiveDate(params: { id: string}) {
        return post('/LiveBroadcastApi/isDelLiveDate', params)
    }
    //回收站回复数据
    isRestore(params: { id: string}) {
        return post('/LiveBroadcastApi/isRestore', params)
    }
    //获取查看录像详情删除
    removeDideo(params: { id: string}) {
        return post('/LiveBroadcastApi/delLiveData', params)
    }
    //获取课表清单
    getTimetableStatistics(params: { start_time: string,auth_status: string,lesson: string,name: string,page: number,page_size: number,departid: string}) {
        return post('/AgencyTimetable/timetableStatistics', params)
    }
    //获取回放列表
    getPlaybackList(params: {id?: string}) {
        return post('/AgencyTimetable/videos', params)
    }

    //获取移除课程列表
    getCourseBlacklist(params: {keyword: string,departid: string,page:number,page_size:number,}) {
        return post('/AgencyTimetable/courseBlacklist', params)
    }
    
    //课表添加移除课程清单
    addCourseBlacklist(params: {teachclassnums: string}) {
        return post('/AgencyTimetable/courseBlacklistAdd', params)
    }
    
    //课表恢复移除课程清单
    recoverCourseBlacklist(params: {teachclassnums: string}) {
        return post('/AgencyTimetable/courseBlacklistRemove', params)
    }

    //获取巡课应用的基础信息
    getAppInfo() {
        return post('/Classmonitoring/ClassmonitoringApi/getAppInfo',{})
    }
    //缓存中获取票据信息
    getTicketCache() {
        return post('/Classmonitoring/ClassmonitoringApi/getTicketCache',{})
    }
    //保存ticket数据到缓存
    saveTicketToCache(params: { ticket: string}){
        return post('/Classmonitoring/ClassmonitoringApi/saveTicketToCache',params) 
    }

    //保存某个用户的教室的巡课的数据
    saveInspectMViewCache(params: { data: Array<any>}){
        return post('/Classmonitoring/ClassmonitoringApi/saveInspectMViewCache',params) 
    }

    //获取某个用户的教室的巡课的数据
    getInspectMViewCache(params: {}){
        return post('/Classmonitoring/ClassmonitoringApi/getInspectMViewCache',params) 
    }

    //巡课系统的校区信息同步课堂派
    syncTelhomeDataToKtpCampus(params: { data: Array<any>}){
        return post('/Classmonitoring/CampusApi/syncTelhomeDataToKtp',params) 
    }
    //巡课系统的楼宇教室信息同步课堂派
    syncTelhomeDataToKtpClassroom(params: { campusId:string, data: Array<any>}){
        return post('/Classmonitoring/ClassroomApi/syncTelhomeDataToKtp',params) 
    }

    //天虹-获取校区信息
    getCampusList(ip:string,params:{tickets: string}){
        return getInspect(ip +'api/basic/GetCampusList',params) 
    }
    //天虹-获取楼栋教室
    getBuildingAndRoom(ip:string,params: { campusId: string, tickets?:string}){
        //return getInspect(ip +'api/classroom/GetBuildingAndRoom',params) 
        return getInspect(ip +'api/basic/GetBuildingAndRoom',params) 
    }
    //天虹-获取学科列表
    getSubjects(ip:string,params: { campusID: string}){
        return getInspect(ip +'api/subject/GetSubjects',params) 
    }
    //天虹-获取校区老师列表
    getTeacherList(ip:string,params: { campusId: string}){
        return getInspect(ip +'/api/basic/GetTeacherList',params) 
    }

    //天虹-获取票据信息
    getTickets(ip:string,params: { appid: string,appsecret:string}){
        return postInspect(ip +'api/auth/GetTickets',params) 
    }
    //天虹-获取实时巡课
    getInspectInfo(ip:string,params: { tickets: string,userName:string,classRoomIp:string}){
        return getInspect(ip +'/api/inspectopen/GetInspectInfo',params) 
    }

    //天虹-获取实时多画面
    getInspectMView(ip:string,params: { tickets: string,userName:string,buildingName:string,pageIndex:number,pageSize:number}){
        return getInspect(ip +'api/inspectopen/GetInspectMView',params) 
    }

    //天虹-获取历史巡课清单
    getInspectHistoryList(ip:string,params: { tickets: string,sfxk:string|number,classRoomIp?:string,subjectName?:string,teacherName?:string,startDate?:string,endDate?:string,pageSize:number,pageIndex:number}){
        return getInspect(ip +'api/inspectopen/GetInspectHistoryList',params) 
    }
    //天虹-获取历史巡课
    getInspectHistoryInfo(ip:string,params: { tickets: string,userName:string,historyId:string}){
        return getInspect(ip +'api/inspectopen/GetInspectHistoryInfo',params) 
    }
    //天虹-获取历史多画面
    getInspectHistoryMView(ip:string,params: { tickets: string,userName:string,buildingName:string,pageIndex:number,pageSize:number}){
        return getInspect(ip +'api/inspectopen/GetInspectHistoryMView',params) 
    }
    //天虹-获取巡课评价记录
    getReportList(ip:string,params: { tickets: string,classRoomIp:string,teacherName:string,subjectName:string,pageIndex:number,pageSize:number}){
        return getInspect(ip +'api/inspectopen/GetReportList',params) 
    }
     //天虹-获取巡课统计地址
     getAccessUrl(ip:string,params: { tickets: string,userName:string,teacherName:string}){
        return getInspect(ip +'api/inspectopen/GetAccessUrl',params) 
    }

}

const LiveClassroomApi = new LiveClassroom()
export default LiveClassroomApi
